import { WebMercatorViewport } from "@wayz/react-gl"
import type { ViewStateProps } from "@wayz/react-gl/lib/gl"

export function getViewPort(viewState: ViewStateProps) {
  const viewport = new WebMercatorViewport(viewState)
  return viewport
}
